/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useContext, useEffect } from 'react';
import { Close, ExpandLess, ExpandMore, CheckCircle, Error as ErrorIcon } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import { AppContext } from 'Context';
import styles from './index.module.css';

const DownloadProgressBox = () => {
  const [isMinimize, setSize] = useState(false);
  const { downloadingFiles, setDownloadBox, isBulkDownloading } = useContext(AppContext);

  const progressBoxCloseHandler = () => {
    setDownloadBox(false);
  };

  // Auto-close when all downloads are completed.
  // Guard on isBulkDownloading: in the "both" (videos + photos) flow, videos
  // finish first and then album photos are fetched/queued. During that gap
  // every tracked file is momentarily 'completed', which would trip this
  // auto-close and hide the panel before the albums ever appear. Staying open
  // while the bulk download is still running prevents that.
  useEffect(() => {
    if (downloadingFiles.length > 0 && !isBulkDownloading) {
      const allCompleted = downloadingFiles.every((file) => file.status === 'completed' || file.status === 'error');
      const hasCompleted = downloadingFiles.some((file) => file.status === 'completed');

      if (allCompleted && hasCompleted) {
        // Wait 2 seconds before closing so user can see completion
        const timer = setTimeout(() => {
          setDownloadBox(false);
        }, 2000);

        return () => clearTimeout(timer);
      }
    }
  }, [downloadingFiles, setDownloadBox, isBulkDownloading]);

  return (
    <>
      <div className={styles.downloadBoxWrap}>
        <div className={styles.header}>
          <div className={styles.headerContent}>
            <div className={styles.headerText}>Downloading files</div>
            <div className={styles.headerAction}>
              {
                isMinimize ? (
                  <ExpandLess onClick={() => setSize(!isMinimize)} className={styles.icon} />
                ) : (
                  <ExpandMore onClick={() => setSize(!isMinimize)} className={styles.icon} />
                )
              }
              {
                downloadingFiles.some((el) => el.status === 'downloading') ? (
                  <div style={{ width: 28 }} />
                ) : (
                  <Close className={styles.icon} onClick={() => progressBoxCloseHandler()} />
                )
              }
            </div>
          </div>
        </div>
        {
          !isMinimize ? (
            <div id="downloadlist">
              {
                downloadingFiles?.map((file) => (
                  <div key={file.id} className={styles.fileItem}>
                    <div className={styles.fileName} id={file.id}>{file.name}</div>
                    <div className={styles.downloadProgress}>{`${file.progress}% downloaded`}</div>
                    <div className={styles.progressIndicator}>
                      {
                        file.status === 'completed' ? (
                          <div className={styles.completedIcon}>
                            <CheckCircle style={{ fontSize: 24, color: '#4CAF50' }} />
                          </div>
                        ) : file.status === 'error' ? (
                          <div className={styles.errorIconWrapper}>
                            <ErrorIcon style={{ fontSize: 24, color: '#F44336' }} />
                          </div>
                        ) : (
                          <CircularProgress size={32} thickness={2.5} style={{ color: '#5aa5ef99' }} />
                        )
                      }
                    </div>
                  </div>
                ))
              }
            </div>
          ) : null
        }
      </div>
    </>
  );
};

export default DownloadProgressBox;
